<template>
    <path :style="{ fill: color }" d="M62.4,57.7c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.3-0.6c-0.2-0.3-0.4-0.5-0.7-0.7
	c-0.5-0.3-1.5-0.3-1.9,0.3c-0.2,0.2-0.2,0.6-0.1,0.8c0,0.2,0.1,0.3,0.2,0.3c0.2,0,0.1-0.5,0.4-0.6c0.3,0,0.7,0.2,0.7,0.5
	c0,0.1,0,0.2-0.1,0.2c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.3,0.1-0.5,0.1c-0.4,0-0.8-0.2-1.1-0.3
	c-0.1-0.1-0.2-0.1-0.3-0.2c-0.6-0.5-1.4-1-2.1-1.3c-0.7-0.3-1.5-0.5-2.2-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.2,0.1-0.3,0.1
	c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1
	c-0.2-0.1-0.5-0.2-0.7-0.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0
	c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
	c-0.8,0.1-1.5,0.5-2.2,1c-0.4,0.2-0.7,0.5-1.1,0.7c-0.2,0.1-0.4,0.2-0.7,0.3c-0.2,0.1-0.6,0.1-0.9,0c-0.3-0.1-0.6-0.3-0.6-0.5
	c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1l0,0c0,0,0,0,0.1,0c0.1-0.1,0.3-0.1,0.5-0.1c0,0,0,0,0,0c0.1,0,0.2,0.3,0.3,0.4
	c0,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0.4-0.5,0.2-0.9-0.1-1.2l0,0c-0.2-0.2-0.5-0.3-0.8-0.4c-0.7-0.1-1.4,0.2-1.8,0.8
	c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.5-0.2,0.8c0.1,0.6,0.5,1.2,0.9,1.6c0.7,0.6,1.7,1,2.6,1.2c0,0,0,0,0,0c1.8,0.3,3.7-0.2,5-1.4
	c0.2,0,0.3,0,0.4,0c0.1,0,0.3,0,0.5,0.1c1,0.9,2.4,1.5,3.8,1.5c1.4,0,3.1-0.4,4-1.5C62.1,58.7,62.5,58.2,62.4,57.7z"/>
</template>

<script>
    import Mouth from './Mouth';

    export default {
        name: 'Mouth7',
        mixins: [Mouth],
    }
</script>
